export enum FeeStatuses {
    Draft = 'D',
    QueuedForApproval = 'Q',
    ApprovedForPayment = 'A',
    Paid = 'P',
    VoucherPayment = 'VP',
}
